import React from "react";
import { useLocation } from "react-router-dom";

import ChatComponent from "../Components/ChatComponent";

const PhysicianCurrentChat = () => {
	const { state } = useLocation();
	return (
		<>
			<ChatComponent tabName={state?.tabName} />
		</>
	);
};

export default PhysicianCurrentChat;
